import type { EnvironmentConfig } from '../../../environments/environment.interface';
import { Assignment } from '../../api/app-types/assignment';

export function normalizeToDayStart(date: Date): Date {
	const normalized = new Date(date);
	normalized.setHours(0, 0, 0, 0);
	return normalized;
}

export function toDayKey(date?: Date | null) {
	if (!date) return undefined;
	return normalizeToDayStart(date).toISOString();
}

export function resolveP3StartDate(assignment?: Assignment): Date | undefined {
	if (!assignment) return undefined;
	const rawDate = assignment.careStartDate ?? assignment.phaseStart;
	if (!rawDate) return undefined;
	const date = new Date(rawDate);
	if (Number.isNaN(date.getTime())) return undefined;
	return normalizeToDayStart(date);
}

export function resolveMinStartDate(env: EnvironmentConfig, p3StartDate?: Date): Date {
	const offsetDays = env.formConfiguration.assignment.minDateOfCommissionOffsetDays;
	const offsetMin = new Date();
	offsetMin.setDate(offsetMin.getDate() - offsetDays);
	offsetMin.setHours(0, 0, 0, 0);
	if (p3StartDate && p3StartDate > offsetMin) return p3StartDate;
	return offsetMin;
}

export function resolveMaxStartDate(): Date {
	return new Date();
}
